import { HttpAuth } from '../../config/Http'
import { changeNotify } from './notify.action'
import { changeLoading } from './loading.action'
import { changeAlert } from './alert.action'
import { change as changeVerifySms } from './sms.action'

export const actionTypes = {
    INDEX: 'COTAS_INDEX',
    SUCCESS: 'COTAS_SUCCESS',
    ERROR: 'COTAS_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

// INDEX

export const indexResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const index = (action_id, query, isLoadMore) => dispatch => {
    
    return HttpAuth.post('/transactions/'+ action_id, query)
            .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data, isLoadMore)))
            .catch(error => {
                dispatch( changeLoading({ open: false }) );
        
                if(typeof error.response !== 'undefined') {
                    if(error.response.status === 400) {
                        if(typeof error.response.data === 'object'){
                            if(typeof error.response.data.error_code !== undefined) {
                                dispatch(changeVerifySms({
                                    open: true,
                                    screen_id: 'transactions.index'
                                }))
                                
                                return false
                            }
                            
                            if(typeof error.response.data.error !== undefined) {
                                if(typeof error.response.data.error === 'string'){
                                    dispatch( changeNotify({
                                        open: true,
                                        class: 'error',
                                        msg: error.response.data.error
                                    }))
                                }
                            }
    
                            if(typeof error.response.data.class !== undefined) {
                                dispatch(changeNotify({
                                    open: true,
                                    msg: error.response.data.msg,
                                    class: error.response.data.class
                                }))
                                dispatch(success(true))
                            }
                        }
                    }
                }
            })
}

// SHOW

export const show = (id) => dispatch => {
    return HttpAuth.get('/transactions/'+ id)
        .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
        .catch(erro => {
            if(erro.response) {
                dispatch(changeNotify({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class
                }))
                dispatch(success(true))
            }
        })
}

// RENOTIFICATE

export const renotificate = (id) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        block: true,
    }))

    return HttpAuth.get('/transactions/renotification/'+ id)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            if(typeof res !== 'undefined'){
                if(res.data.success === 200) {
                    dispatch(changeAlert({
                        open: true,
                        msg: res.data.msg,
                        class: res.data.class,
                        time: 5000
                    }))
                }
            }
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))
            if(erro.response) {
                dispatch(changeAlert({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class,
                    time: 5000
                }))
                dispatch(success(true))
            }
        })
}

// CONSULT

export const consult = (id) => dispatch => {
    dispatch(changeLoading({ 
        open: true
    }))

    return HttpAuth.get('/transactions/consult/'+ id)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            if(typeof res !== 'undefined'){
                if(res.data.success === 200) {
                    dispatch(show(id))
                    dispatch(changeAlert({
                        open: true,
                        msg: res.data.msg,
                        class: res.data.class,
                        time: 5000
                    }))
                }
            }
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))
            if(erro.response) {
                dispatch(changeAlert({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class,
                    time: 5000
                }))
                dispatch(success(true))
            }else {
                dispatch(changeAlert({
                    open: true,
                    msg: 'O Banco paggue não esta retornando a solicitação.',
                    class: 'error',
                    time: 5000
                }))
            }
        })
}